import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import fileDownload from 'js-file-download';
import {
	getUploadedFilesRequest,
	getUploadedFilesSuccess,
	getProcessingTypesRequest,
	getProcessingTypesSuccess,
	processFileRequest,
	processFileSuccess,
	processFileError,
	downloadFileRequest,
	downloadFileSuccess,
	getFileStatusesRequest,
	getFileStatusesSuccess,
	getEmInvoicingFeeTypesRequest,
	getEmInvoicingFeeTypesSuccess,
} from './reducer';
import {
	TSalesProcessingRequest,
	TSalesProcessingResponsePayload,
	TProcessingTypesResponsePayload,
	TProcessFileRequest,
	TDownloadSalesReportRequest,
	TDownloadSalesReportResponsePayload,
	TProcessFileResponsePayload,
	TFileStatusesResponsePayload,
	TEmInvoicingFeeTypesResponsePayload,
} from './types';

function* getUploadedFilesRequestWorker(action: PayloadAction<TSalesProcessingRequest>) {
	const { payload } = action;
	try {
		const response: TSalesProcessingResponsePayload = yield call(
			api.salesProcessing.getUploadedFiles,
			payload,
		);
		console.log('getUploadedFilesRequestWorker response', response);
		yield put(getUploadedFilesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* getProcessingTypesRequestWorker() {
	try {
		const response: TProcessingTypesResponsePayload = yield call(
			api.salesProcessing.getProcessingTypes,
		);
		console.log('getProcessingTypesRequestWorker response', response);
		yield put(getProcessingTypesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* processFileRequestWorker(action: PayloadAction<TProcessFileRequest>) {
	const { payload } = action;
	try {
		const response: TProcessFileResponsePayload = yield call(
			api.salesProcessing.processFile,
			payload,
		);
		console.log('processFileRequestWorker response', response);
		yield put(processFileSuccess(response));
		yield put(getUploadedFilesRequest(payload.reloadBody));
		notificationContainer('Sales Report processing started', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
			yield put(processFileError(String(error?.response?.data?.message ?? error ?? 'Error!')));
		}
	}
}

function* downloadFileRequestWorker(action: PayloadAction<TDownloadSalesReportRequest>) {
	const { payload } = action;
	try {
		const response: TDownloadSalesReportResponsePayload = yield call(
			api.salesProcessing.downloadFile,
			payload.fileId,
		);
		yield put(downloadFileSuccess());
		if (response) {
			fileDownload(response, payload.fileName);
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
			yield put(downloadFileSuccess());
		}
	}
}

function* getFileStatusesRequestWorker() {
	try {
		const response: TFileStatusesResponsePayload = yield call(api.salesProcessing.getFileStatuses);
		yield put(getFileStatusesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* getEmInvoicingFeeTypesRequestWorker() {
	try {
		const response: TEmInvoicingFeeTypesResponsePayload = yield call(
			api.salesProcessing.getEmInvoicingFeeTypes,
		);
		yield put(getEmInvoicingFeeTypesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

export function* salesProcessingSaga() {
	yield takeEvery(getUploadedFilesRequest.type, getUploadedFilesRequestWorker);
	yield takeEvery(getProcessingTypesRequest.type, getProcessingTypesRequestWorker);
	yield takeEvery(processFileRequest.type, processFileRequestWorker);
	yield takeEvery(downloadFileRequest.type, downloadFileRequestWorker);
	yield takeEvery(getFileStatusesRequest.type, getFileStatusesRequestWorker);
	yield takeEvery(getEmInvoicingFeeTypesRequest.type, getEmInvoicingFeeTypesRequestWorker);
}
